import React from "react";
import { TApplicantReportingPeriodPresentationModel } from "../../../../presenter/applicants/model/ApplicantReportingPeriodPresentationModel";
import { TReportingPeriodFormTypePresentationModel } from "../../../../model/form/mappers/ReportingPeriodFormTypeListMapper";
import { TBoFormVersionPresentationModel } from "../../../../presenter/applicants/model/BoFormVersionPresentationModel";
import EvaluationsGrid from "../../../components/applicants/details/EvaluationsGrid";
import ReportingPeriodFormVersionGrid from "../../../components/applicants/details/ReportingPeriodFormVersionGrid";
import { IFormVersionEvaluationsPresenter } from "../../../../presenter/evaluation/FormVersionEvaluationsPresenter";
import { IRegisteredApplicant } from "../../../../model/applicant/RegisteredApplicant";
import { IConfiguration } from "../../../../model/config/Configuration";

export interface Props {
  reportingPeriods: TApplicantReportingPeriodPresentationModel[];
  translate: any;
  formTypes: TReportingPeriodFormTypePresentationModel[];
  formVersions: TBoFormVersionPresentationModel[];
  onExpandReportingPeriod: any;
  onExpandFormType: any;
  onExpandFormVersion: any;
  formTypesLoader?: boolean;
  formVersionsLoader?: boolean;
  formVersionEvaluationsPresenter?: IFormVersionEvaluationsPresenter;
  onChangeModalVisible: any;
  applicant?: IRegisteredApplicant;
  addNewDraftFormVersion: any;
  configuration: IConfiguration;
}

export interface State {}

export default class ApplicantEvaluationsGrid extends React.Component<
  Props,
  State
> {
  render() {
    const {
      reportingPeriods,
      translate,
      formTypes,
      onExpandReportingPeriod,
      onExpandFormType,
      formVersions,
      formTypesLoader,
      formVersionsLoader,
      onExpandFormVersion,
      formVersionEvaluationsPresenter,
      onChangeModalVisible,
      applicant,
      addNewDraftFormVersion,
      configuration
    } = this.props;

    return (
      <ReportingPeriodFormVersionGrid
        title={translate("grids.applicant-evaluations")}
        reportingPeriods={reportingPeriods}
        translate={translate}
        formTypes={formTypes}
        onExpandReportingPeriod={onExpandReportingPeriod}
        formVersions={formVersions}
        formTypesLoader={formTypesLoader}
        formVersionsLoader={formVersionsLoader}
        onExpandFormVersion={onExpandFormVersion}
        onExpandFormType={onExpandFormType}
        onChangeModalVisible={onChangeModalVisible}
        applicant={applicant}
        addNewDraftFormVersion={addNewDraftFormVersion}
        isApplicantEvaluations={true}
        configuration={configuration}
      >
        {formVersionEvaluationsPresenter && (
          <EvaluationsGrid
            applicantId={applicant?.id}
            {...formVersionEvaluationsPresenter}
          />
        )}
      </ReportingPeriodFormVersionGrid>
    );
  }
}
